import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesGrid = () => {
  const features = [
    {
      id: 1,
      icon: 'Target',
      title: 'Topic Selection & Market Research',
      description: 'AI analyzes Amazon BSR data to recommend 20 profitable book topics with proven market demand',
      color: 'text-primary'
    },
    {
      id: 2,
      icon: 'Mic',
      title: 'Writing Voice Capture',
      description: 'Upload your existing content and AI learns your unique writing style and tone',
      color: 'text-secondary'
    },
    {
      id: 3,
      icon: 'List',
      title: 'Detailed Outline Creation',
      description: 'Generate comprehensive table of contents with chapter breakdowns and key points',
      color: 'text-accent'
    },
    {
      id: 4,
      icon: 'GitBranch',
      title: 'Flexible Writing Paths',
      description: 'Choose automatic full manuscript generation or interactive chapter-by-chapter writing',
      color: 'text-success'
    },
    {
      id: 5,
      icon: 'Zap',
      title: 'Full Manuscript Generation',
      description: 'AI writes your complete book automatically while maintaining your authentic voice',
      color: 'text-warning'
    },
    {
      id: 6,
      icon: 'Edit',
      title: 'Chapter-by-Chapter Writing',
      description: 'Collaborate with AI on each chapter with real-time feedback and refinement',
      color: 'text-error'
    },
    {
      id: 7,
      icon: 'FileText',
      title: 'Print Formatting (KDP)',
      description: 'Professional formatting for Amazon KDP with multiple trim size options',
      color: 'text-primary'
    },
    {
      id: 8,
      icon: 'Smartphone',
      title: 'Ebook Formatting',
      description: 'Optimized formatting for Kindle and other ebook platforms',
      color: 'text-secondary'
    },
    {
      id: 9,
      icon: 'Image',
      title: 'Book Cover Design',
      description: 'AI-generated covers based on competitor research with front and back design',
      color: 'text-accent'
    },
    {
      id: 10,
      icon: 'Tag',
      title: 'KDP Metadata Generation',
      description: 'Automatic creation of categories, keywords, and descriptions for maximum visibility',
      color: 'text-success'
    },
    {
      id: 11,
      icon: 'Send',
      title: 'Publishing Guidance',
      description: 'Step-by-step instructions and automation for Amazon KDP publishing process',
      color: 'text-warning'
    }
  ];

  return (
    <section id="features-section" className="pt-20 lg:pt-24 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-secondary/10 rounded-full mb-6">
            <Icon name="Sparkles" size={16} color="var(--color-secondary)" />
            <span className="text-sm font-medium text-secondary">11 AI Agents Working For You</span>
          </div>

          <h2 className="text-3xl lg:text-5xl font-heading font-bold text-foreground mb-6">
            Complete Book Creation Workflow
          </h2>

          <p className="text-lg text-muted-foreground">
            Our intelligent AI agents handle every aspect of book creation, from initial research to final publishing, ensuring professional quality at every step.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features?.map((feature) => (
            <div
              key={feature?.id}
              className="group bg-card border border-border rounded-xl p-6 hover:shadow-lg hover:border-primary/50 transition-all duration-300"
            >
              <div className={`w-12 h-12 rounded-lg bg-gradient-to-br from-${feature?.color}/10 to-${feature?.color}/5 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={feature?.icon} size={24} className={feature?.color} />
              </div>

              <h3 className="text-lg font-heading font-semibold text-foreground mb-3">
                {feature?.title}
              </h3>

              <p className="text-sm text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>

              <div className="mt-4 pt-4 border-t border-border">
                <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                  <Icon name="Zap" size={14} color="var(--color-accent)" />
                  <span>AI Agent {feature?.id}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-2 px-6 py-3 bg-success/10 rounded-full">
            <Icon name="CheckCircle" size={20} color="var(--color-success)" />
            <span className="text-sm font-medium text-success">All agents work seamlessly together</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesGrid;